// source: assistant-deployment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.assistant_api.AssistantApiDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantApiDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.AssistantDebuggerDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantDebuggerDeployment.IconCase', null, global);
goog.exportSymbol('proto.assistant_api.AssistantDebuggerDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.AssistantDeploymentCapturer', null, global);
goog.exportSymbol('proto.assistant_api.AssistantPhoneDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantPhoneDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWebpluginDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWebpluginDeployment.IconCase', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWebpluginDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWhatsappDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWhatsappDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantApiDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantDebuggerDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantPhoneDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantWebpluginDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantWhatsappDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.DeploymentAudioProvider', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantDeploymentRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.DeploymentAudioProvider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.DeploymentAudioProvider.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.DeploymentAudioProvider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.DeploymentAudioProvider.displayName = 'proto.assistant_api.DeploymentAudioProvider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantDeploymentCapturer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantDeploymentCapturer.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantDeploymentCapturer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantDeploymentCapturer.displayName = 'proto.assistant_api.AssistantDeploymentCapturer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWebpluginDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantWebpluginDeployment.repeatedFields_, proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_);
};
goog.inherits(proto.assistant_api.AssistantWebpluginDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWebpluginDeployment.displayName = 'proto.assistant_api.AssistantWebpluginDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantPhoneDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantPhoneDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantPhoneDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantPhoneDeployment.displayName = 'proto.assistant_api.AssistantPhoneDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWhatsappDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantWhatsappDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantWhatsappDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWhatsappDeployment.displayName = 'proto.assistant_api.AssistantWhatsappDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantDebuggerDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantDebuggerDeployment.repeatedFields_, proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_);
};
goog.inherits(proto.assistant_api.AssistantDebuggerDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantDebuggerDeployment.displayName = 'proto.assistant_api.AssistantDebuggerDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantApiDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantApiDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantApiDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantApiDeployment.displayName = 'proto.assistant_api.AssistantApiDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantApiDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantApiDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantApiDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantApiDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantApiDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantApiDeploymentResponse.displayName = 'proto.assistant_api.AssistantApiDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantPhoneDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantPhoneDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantPhoneDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantPhoneDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantPhoneDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantPhoneDeploymentResponse.displayName = 'proto.assistant_api.AssistantPhoneDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantWhatsappDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantWhatsappDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantWhatsappDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWhatsappDeploymentResponse.displayName = 'proto.assistant_api.AssistantWhatsappDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantDebuggerDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantDebuggerDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantDebuggerDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantDebuggerDeploymentResponse.displayName = 'proto.assistant_api.AssistantDebuggerDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantWebpluginDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantWebpluginDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantWebpluginDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWebpluginDeploymentResponse.displayName = 'proto.assistant_api.AssistantWebpluginDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantDeploymentRequest.displayName = 'proto.assistant_api.GetAssistantDeploymentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.DeploymentAudioProvider.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.DeploymentAudioProvider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.DeploymentAudioProvider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeploymentAudioProvider.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    audioprovider: jspb.Message.getFieldWithDefault(msg, 2, ""),
    audiooptionsList: jspb.Message.toObjectList(msg.getAudiooptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    audioproviderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    audiotype: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.DeploymentAudioProvider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.DeploymentAudioProvider;
  return proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.DeploymentAudioProvider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudioprovider(value);
      break;
    case 3:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAudiooptions(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAudioproviderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiotype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.DeploymentAudioProvider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAudioprovider();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAudiooptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getAudioproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAudiotype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string audioProvider = 2;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudioprovider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setAudioprovider = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Metadata audioOptions = 3;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudiooptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 3));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
*/
proto.assistant_api.DeploymentAudioProvider.prototype.setAudiooptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.addAudiooptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.clearAudiooptionsList = function() {
  return this.setAudiooptionsList([]);
};


/**
 * optional uint64 audioProviderId = 4;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudioproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setAudioproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string audioType = 6;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudiotype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setAudiotype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantDeploymentCapturer.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantDeploymentCapturer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantDeploymentCapturer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDeploymentCapturer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantdeploymentid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    capturertype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    capturerproviderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    capturerprovider: jspb.Message.getFieldWithDefault(msg, 5, ""),
    captureroptionsList: jspb.Message.toObjectList(msg.getCaptureroptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantDeploymentCapturer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantDeploymentCapturer;
  return proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantDeploymentCapturer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantdeploymentid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapturertype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCapturerproviderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapturerprovider(value);
      break;
    case 6:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addCaptureroptions(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantDeploymentCapturer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantdeploymentid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getCapturertype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCapturerproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getCapturerprovider();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCaptureroptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantDeploymentId = 2;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getAssistantdeploymentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setAssistantdeploymentid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string capturerType = 3;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getCapturertype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setCapturertype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 capturerProviderId = 4;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getCapturerproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setCapturerproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string capturerProvider = 5;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getCapturerprovider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setCapturerprovider = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated Metadata capturerOptions = 6;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getCaptureroptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 6));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
*/
proto.assistant_api.AssistantDeploymentCapturer.prototype.setCaptureroptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.addCaptureroptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.clearCaptureroptionsList = function() {
  return this.setCaptureroptionsList([]);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDeploymentCapturer} returns this
 */
proto.assistant_api.AssistantDeploymentCapturer.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantWebpluginDeployment.repeatedFields_ = [17,20];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_ = [[15,16]];

/**
 * @enum {number}
 */
proto.assistant_api.AssistantWebpluginDeployment.IconCase = {
  ICON_NOT_SET: 0,
  URL: 15,
  RAW: 16
};

/**
 * @return {proto.assistant_api.AssistantWebpluginDeployment.IconCase}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getIconCase = function() {
  return /** @type {proto.assistant_api.AssistantWebpluginDeployment.IconCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWebpluginDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    role: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    experties: jspb.Message.getFieldWithDefault(msg, 9, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ending: jspb.Message.getFieldWithDefault(msg, 12, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    capturersList: jspb.Message.toObjectList(msg.getCapturersList(),
    proto.assistant_api.AssistantDeploymentCapturer.toObject, includeInstance),
    url: jspb.Message.getFieldWithDefault(msg, 15, ""),
    raw: (f = msg.getRaw()) && common_pb.Content.toObject(includeInstance, f),
    suggestionList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    helpcenterenabled: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    productcatalogenabled: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    articlecatalogenabled: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    uploadfileenabled: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.AssistantWebpluginDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWebpluginDeployment;
  return proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnding(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 17:
      var value = new proto.assistant_api.AssistantDeploymentCapturer;
      reader.readMessage(value,proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader);
      msg.addCapturers(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 16:
      var value = new common_pb.Content;
      reader.readMessage(value,common_pb.Content.deserializeBinaryFromReader);
      msg.setRaw(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestion(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHelpcenterenabled(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProductcatalogenabled(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArticlecatalogenabled(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUploadfileenabled(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExperties();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getCapturersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRaw();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getSuggestionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getHelpcenterenabled();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getProductcatalogenabled();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getArticlecatalogenabled();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getUploadfileenabled();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string role = 7;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tone = 8;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getTone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setTone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string experties = 9;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getExperties = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setExperties = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string ending = 12;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getEnding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setEnding = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearEnding = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasEnding = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated AssistantDeploymentCapturer capturers = 17;
 * @return {!Array<!proto.assistant_api.AssistantDeploymentCapturer>}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getCapturersList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantDeploymentCapturer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantDeploymentCapturer, 17));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantDeploymentCapturer>} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setCapturersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.assistant_api.AssistantDeploymentCapturer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.addCapturers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.assistant_api.AssistantDeploymentCapturer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearCapturersList = function() {
  return this.setCapturersList([]);
};


/**
 * optional string url = 15;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setUrl = function(value) {
  return jspb.Message.setOneofField(this, 15, proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearUrl = function() {
  return jspb.Message.setOneofField(this, 15, proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasUrl = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Content raw = 16;
 * @return {?proto.Content}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getRaw = function() {
  return /** @type{?proto.Content} */ (
    jspb.Message.getWrapperField(this, common_pb.Content, 16));
};


/**
 * @param {?proto.Content|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setRaw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.assistant_api.AssistantWebpluginDeployment.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearRaw = function() {
  return this.setRaw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasRaw = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated string suggestion = 20;
 * @return {!Array<string>}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getSuggestionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setSuggestionList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.addSuggestion = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearSuggestionList = function() {
  return this.setSuggestionList([]);
};


/**
 * optional bool helpCenterEnabled = 21;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getHelpcenterenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setHelpcenterenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool productCatalogEnabled = 22;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getProductcatalogenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setProductcatalogenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool articleCatalogEnabled = 23;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getArticlecatalogenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setArticlecatalogenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool uploadFileEnabled = 24;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getUploadfileenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setUploadfileenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantPhoneDeployment.repeatedFields_ = [17,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantPhoneDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantPhoneDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    role: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    experties: jspb.Message.getFieldWithDefault(msg, 9, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ending: jspb.Message.getFieldWithDefault(msg, 12, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    phoneprovidername: jspb.Message.getFieldWithDefault(msg, 15, ""),
    phoneproviderid: jspb.Message.getFieldWithDefault(msg, 16, "0"),
    phoneoptionsList: jspb.Message.toObjectList(msg.getPhoneoptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    capturersList: jspb.Message.toObjectList(msg.getCapturersList(),
    proto.assistant_api.AssistantDeploymentCapturer.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.AssistantPhoneDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantPhoneDeployment;
  return proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantPhoneDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnding(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneprovidername(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setPhoneproviderid(value);
      break;
    case 17:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addPhoneoptions(value);
      break;
    case 18:
      var value = new proto.assistant_api.AssistantDeploymentCapturer;
      reader.readMessage(value,proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader);
      msg.addCapturers(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantPhoneDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExperties();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getPhoneprovidername();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPhoneproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      16,
      f
    );
  }
  f = message.getPhoneoptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCapturersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string role = 7;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tone = 8;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getTone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setTone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string experties = 9;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getExperties = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setExperties = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string ending = 12;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getEnding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setEnding = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearEnding = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasEnding = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string phoneProviderName = 15;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getPhoneprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setPhoneprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint64 phoneProviderId = 16;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getPhoneproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setPhoneproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 16, value);
};


/**
 * repeated Metadata phoneOptions = 17;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getPhoneoptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 17));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setPhoneoptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.addPhoneoptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearPhoneoptionsList = function() {
  return this.setPhoneoptionsList([]);
};


/**
 * repeated AssistantDeploymentCapturer capturers = 18;
 * @return {!Array<!proto.assistant_api.AssistantDeploymentCapturer>}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getCapturersList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantDeploymentCapturer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantDeploymentCapturer, 18));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantDeploymentCapturer>} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setCapturersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.assistant_api.AssistantDeploymentCapturer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.addCapturers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.assistant_api.AssistantDeploymentCapturer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearCapturersList = function() {
  return this.setCapturersList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantWhatsappDeployment.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWhatsappDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    role: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    experties: jspb.Message.getFieldWithDefault(msg, 9, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ending: jspb.Message.getFieldWithDefault(msg, 12, ""),
    whatsappprovidername: jspb.Message.getFieldWithDefault(msg, 15, ""),
    whatsappproviderid: jspb.Message.getFieldWithDefault(msg, 16, "0"),
    whatsappoptionsList: jspb.Message.toObjectList(msg.getWhatsappoptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.AssistantWhatsappDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWhatsappDeployment;
  return proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnding(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setWhatsappprovidername(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setWhatsappproviderid(value);
      break;
    case 17:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addWhatsappoptions(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExperties();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getWhatsappprovidername();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getWhatsappproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      16,
      f
    );
  }
  f = message.getWhatsappoptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string role = 7;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tone = 8;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getTone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setTone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string experties = 9;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getExperties = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setExperties = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string ending = 12;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getEnding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setEnding = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearEnding = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasEnding = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string whatsappProviderName = 15;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getWhatsappprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setWhatsappprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint64 whatsappProviderId = 16;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getWhatsappproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setWhatsappproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 16, value);
};


/**
 * repeated Metadata whatsappOptions = 17;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getWhatsappoptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 17));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setWhatsappoptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.addWhatsappoptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearWhatsappoptionsList = function() {
  return this.setWhatsappoptionsList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantDebuggerDeployment.repeatedFields_ = [18,20];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_ = [[15,16]];

/**
 * @enum {number}
 */
proto.assistant_api.AssistantDebuggerDeployment.IconCase = {
  ICON_NOT_SET: 0,
  URL: 15,
  RAW: 16
};

/**
 * @return {proto.assistant_api.AssistantDebuggerDeployment.IconCase}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getIconCase = function() {
  return /** @type {proto.assistant_api.AssistantDebuggerDeployment.IconCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantDebuggerDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    role: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    experties: jspb.Message.getFieldWithDefault(msg, 9, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ending: jspb.Message.getFieldWithDefault(msg, 12, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    capturersList: jspb.Message.toObjectList(msg.getCapturersList(),
    proto.assistant_api.AssistantDeploymentCapturer.toObject, includeInstance),
    url: jspb.Message.getFieldWithDefault(msg, 15, ""),
    raw: (f = msg.getRaw()) && common_pb.Content.toObject(includeInstance, f),
    suggestionList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.AssistantDebuggerDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantDebuggerDeployment;
  return proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnding(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 18:
      var value = new proto.assistant_api.AssistantDeploymentCapturer;
      reader.readMessage(value,proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader);
      msg.addCapturers(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 16:
      var value = new common_pb.Content;
      reader.readMessage(value,common_pb.Content.deserializeBinaryFromReader);
      msg.setRaw(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestion(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExperties();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getCapturersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRaw();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getSuggestionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string role = 7;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tone = 8;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getTone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setTone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string experties = 9;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getExperties = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setExperties = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string ending = 12;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getEnding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setEnding = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearEnding = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasEnding = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated AssistantDeploymentCapturer capturers = 18;
 * @return {!Array<!proto.assistant_api.AssistantDeploymentCapturer>}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getCapturersList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantDeploymentCapturer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantDeploymentCapturer, 18));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantDeploymentCapturer>} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setCapturersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.assistant_api.AssistantDeploymentCapturer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.addCapturers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.assistant_api.AssistantDeploymentCapturer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearCapturersList = function() {
  return this.setCapturersList([]);
};


/**
 * optional string url = 15;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setUrl = function(value) {
  return jspb.Message.setOneofField(this, 15, proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearUrl = function() {
  return jspb.Message.setOneofField(this, 15, proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasUrl = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Content raw = 16;
 * @return {?proto.Content}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getRaw = function() {
  return /** @type{?proto.Content} */ (
    jspb.Message.getWrapperField(this, common_pb.Content, 16));
};


/**
 * @param {?proto.Content|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setRaw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.assistant_api.AssistantDebuggerDeployment.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearRaw = function() {
  return this.setRaw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasRaw = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated string suggestion = 20;
 * @return {!Array<string>}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getSuggestionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setSuggestionList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.addSuggestion = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearSuggestionList = function() {
  return this.setSuggestionList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantApiDeployment.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantApiDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantApiDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantApiDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    role: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    experties: jspb.Message.getFieldWithDefault(msg, 9, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ending: jspb.Message.getFieldWithDefault(msg, 12, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    capturersList: jspb.Message.toObjectList(msg.getCapturersList(),
    proto.assistant_api.AssistantDeploymentCapturer.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.AssistantApiDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantApiDeployment;
  return proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantApiDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnding(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 15:
      var value = new proto.assistant_api.AssistantDeploymentCapturer;
      reader.readMessage(value,proto.assistant_api.AssistantDeploymentCapturer.deserializeBinaryFromReader);
      msg.addCapturers(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantApiDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantApiDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExperties();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getCapturersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.assistant_api.AssistantDeploymentCapturer.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string role = 7;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tone = 8;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getTone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setTone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string experties = 9;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getExperties = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setExperties = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string ending = 12;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getEnding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setEnding = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearEnding = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasEnding = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated AssistantDeploymentCapturer capturers = 15;
 * @return {!Array<!proto.assistant_api.AssistantDeploymentCapturer>}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getCapturersList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantDeploymentCapturer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantDeploymentCapturer, 15));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantDeploymentCapturer>} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setCapturersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.assistant_api.AssistantDeploymentCapturer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantDeploymentCapturer}
 */
proto.assistant_api.AssistantApiDeployment.prototype.addCapturers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.assistant_api.AssistantDeploymentCapturer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearCapturersList = function() {
  return this.setCapturersList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantApiDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantApiDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deployment: (f = msg.getDeployment()) && proto.assistant_api.AssistantApiDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantApiDeploymentRequest}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantApiDeploymentRequest;
  return proto.assistant_api.CreateAssistantApiDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantApiDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantApiDeploymentRequest}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantApiDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader);
      msg.setDeployment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantApiDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantApiDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeployment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantApiDeployment deployment = 1;
 * @return {?proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.getDeployment = function() {
  return /** @type{?proto.assistant_api.AssistantApiDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantApiDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantApiDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantApiDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.setDeployment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantApiDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.clearDeployment = function() {
  return this.setDeployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantApiDeploymentRequest.prototype.hasDeployment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantApiDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantApiDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantApiDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse}
 */
proto.assistant_api.AssistantApiDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantApiDeploymentResponse;
  return proto.assistant_api.AssistantApiDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantApiDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse}
 */
proto.assistant_api.AssistantApiDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantApiDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantApiDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantApiDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantApiDeployment data = 3;
 * @return {?proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantApiDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantApiDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantApiDeployment|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
*/
proto.assistant_api.AssistantApiDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
*/
proto.assistant_api.AssistantApiDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantPhoneDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deployment: (f = msg.getDeployment()) && proto.assistant_api.AssistantPhoneDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantPhoneDeploymentRequest;
  return proto.assistant_api.CreateAssistantPhoneDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantPhoneDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader);
      msg.setDeployment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantPhoneDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeployment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantPhoneDeployment deployment = 1;
 * @return {?proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.getDeployment = function() {
  return /** @type{?proto.assistant_api.AssistantPhoneDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantPhoneDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantPhoneDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.setDeployment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantPhoneDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.clearDeployment = function() {
  return this.setDeployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantPhoneDeploymentRequest.prototype.hasDeployment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantPhoneDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantPhoneDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantPhoneDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantPhoneDeploymentResponse;
  return proto.assistant_api.AssistantPhoneDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantPhoneDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantPhoneDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantPhoneDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantPhoneDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantPhoneDeployment data = 3;
 * @return {?proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantPhoneDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantPhoneDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantPhoneDeployment|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
*/
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
*/
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deployment: (f = msg.getDeployment()) && proto.assistant_api.AssistantWhatsappDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantWhatsappDeploymentRequest;
  return proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantWhatsappDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader);
      msg.setDeployment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeployment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantWhatsappDeployment deployment = 1;
 * @return {?proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.getDeployment = function() {
  return /** @type{?proto.assistant_api.AssistantWhatsappDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWhatsappDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantWhatsappDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.setDeployment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantWhatsappDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.clearDeployment = function() {
  return this.setDeployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantWhatsappDeploymentRequest.prototype.hasDeployment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWhatsappDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWhatsappDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWhatsappDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWhatsappDeploymentResponse;
  return proto.assistant_api.AssistantWhatsappDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWhatsappDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWhatsappDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWhatsappDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWhatsappDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWhatsappDeployment data = 3;
 * @return {?proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWhatsappDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWhatsappDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWhatsappDeployment|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
*/
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
*/
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deployment: (f = msg.getDeployment()) && proto.assistant_api.AssistantDebuggerDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantDebuggerDeploymentRequest;
  return proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantDebuggerDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader);
      msg.setDeployment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeployment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantDebuggerDeployment deployment = 1;
 * @return {?proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.getDeployment = function() {
  return /** @type{?proto.assistant_api.AssistantDebuggerDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantDebuggerDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantDebuggerDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.setDeployment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDebuggerDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.clearDeployment = function() {
  return this.setDeployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDebuggerDeploymentRequest.prototype.hasDeployment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantDebuggerDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantDebuggerDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantDebuggerDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantDebuggerDeploymentResponse;
  return proto.assistant_api.AssistantDebuggerDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantDebuggerDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantDebuggerDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantDebuggerDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantDebuggerDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantDebuggerDeployment data = 3;
 * @return {?proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantDebuggerDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantDebuggerDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantDebuggerDeployment|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
*/
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
*/
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deployment: (f = msg.getDeployment()) && proto.assistant_api.AssistantWebpluginDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantWebpluginDeploymentRequest;
  return proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantWebpluginDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader);
      msg.setDeployment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeployment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantWebpluginDeployment deployment = 1;
 * @return {?proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.getDeployment = function() {
  return /** @type{?proto.assistant_api.AssistantWebpluginDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebpluginDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantWebpluginDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.setDeployment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantWebpluginDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.clearDeployment = function() {
  return this.setDeployment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantWebpluginDeploymentRequest.prototype.hasDeployment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWebpluginDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWebpluginDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWebpluginDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWebpluginDeploymentResponse;
  return proto.assistant_api.AssistantWebpluginDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWebpluginDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebpluginDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWebpluginDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWebpluginDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWebpluginDeployment data = 3;
 * @return {?proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWebpluginDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebpluginDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWebpluginDeployment|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
*/
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
*/
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest}
 */
proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantDeploymentRequest;
  return proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest}
 */
proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest} returns this
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


goog.object.extend(exports, proto.assistant_api);
